"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VestingClaimUploadDialog = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const mui_dialog_form_1 = require("@dzambalaorg/mui-dialog-form");
const validation_1 = require("./validation");
const file_input_1 = require("./file-input");
const popover_1 = require("./popover");
const VestingClaimUploadDialog = (props) => {
    const { initialValues, ...rest } = props;
    return ((0, jsx_runtime_1.jsx)(mui_dialog_form_1.FormDialog, { initialValues: initialValues, validationSchema: validation_1.validationSchema, message: "dialogs.upload", testId: "VestingClaimUploadDialog", action: (0, jsx_runtime_1.jsx)(popover_1.VestingClaimInfoPopover, {}), ...rest, children: (0, jsx_runtime_1.jsx)(file_input_1.FileInput, { initialValues: initialValues }) }));
};
exports.VestingClaimUploadDialog = VestingClaimUploadDialog;
//# sourceMappingURL=index.js.map